module.exports = __webpack_public_path__ + "static/media/CONCIEN Y PREV.732e6219.png";